import { classes, getFilteredCountRatio } from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Link } from 'react-router-dom';

import {
  boldLineageItemClass,
  cartoucheContentInfoItemClass,
  CartoucheIconContainer,
  CartoucheWrapper,
  ContentInfoContainer,
  LineageContentInfoItemBarRow,
  LineageContentInfoItemLabelRow,
} from '../style/LineageCartoucheStyles';
import { SmallInlineFadeInSpinner } from '../widgets/SmallInlineFadeInSpinner';
import { LineageFilteredBar } from './LineageFilteredBar';
import { LineageIconButton } from './LineageIconButton';
import { LineageItemProps } from './LineageItemProps';

export interface LineageCartoucheProps {
  readonly lineageItems: ReadonlyArray<LineageItemProps>;
}

export class LineageCartouche extends React.Component<LineageCartoucheProps> {

  private renderCartouche(): JSX.Element {
    return (
      <CartoucheIconContainer>
        {this.props.lineageItems.map(item => (
          <LineageIconButton
            isCurrentPane={item.isCurrentPane}
            linkHref={item.linkHref}
            lineageItemType={item.lineageItemType}
            buttonAltText={item.buttonAltText}
            key={item.lineageItemType}
            inCartouche={true}
          />
        ))}
      </CartoucheIconContainer>
    );
  }

  private renderContentInfoContainer(): JSX.Element {
    return (
      <ContentInfoContainer>
        {
          this.props.lineageItems.map(item => {
            return (
              <Link to={item.linkHref} className={cartoucheContentInfoItemClass} key={item.lineageItemType}>
                <LineageContentInfoItemLabelRow>
                  <span className={classes(item.isCurrentPane && boldLineageItemClass)} title={item.label}>
                    {item.label}
                  </span>
                  {item.countLoading ? <SmallInlineFadeInSpinner /> : null}
                </LineageContentInfoItemLabelRow>
                <LineageContentInfoItemBarRow>
                  <span className={classes(item.isCurrentPane && boldLineageItemClass)}>
                    {item.filteredCount != null ? getFilteredCountRatio(item.filteredCount, item.unfilteredCount) : item.unfilteredCount}
                  </span>
                </LineageContentInfoItemBarRow>
                <LineageContentInfoItemBarRow>
                  {<LineageFilteredBar filteredCount={item.filteredCount} unfilteredCount={item.unfilteredCount} />}
                </LineageContentInfoItemBarRow>
              </Link>
            );
          })
        }
      </ContentInfoContainer>
    );
  }

  public render(): JSX.Element {
    return (
      <CartoucheWrapper>
        {this.renderCartouche()}
        {this.renderContentInfoContainer()}
      </CartoucheWrapper>
    );
  }
}
